import {
    ChallengesFilterLevel,
    SetChallengesFilterLevelParams
} from './level-filter.types';

type UpdateLevelFilterByValueParams = {
    updatedLevelFilter: SetChallengesFilterLevelParams
    currentLevelFilter: ChallengesFilterLevel
};

export const sortFilterLevels = (values: ChallengesFilterLevel) => Array.from(new Set(values)).sort((a, b) => a - b);

export const updateLevelFilterByValue = ({
    updatedLevelFilter,
    currentLevelFilter
}: UpdateLevelFilterByValueParams) => {
    return updatedLevelFilter
        ? currentLevelFilter.includes(updatedLevelFilter)
            ? currentLevelFilter.filter(value => value !== updatedLevelFilter)
            : [...currentLevelFilter, updatedLevelFilter]
        : [];
};
